import { CategoriaFiltroDTO } from "./CategoriaFiltro.DTO";
import { ITagDTO, TagDTO } from "./Tag.DTO";
import { Nilable } from "@shared/utils";

export interface ICuotaDTO {
    id: number;
    tag: Nilable<ITagDTO>;
    tag_id: Nilable<number>;
    type: Nilable<number>;
    quota: string;
    reached_quota: Nilable<number>;
}

export class CuotaDTO {
    public id = 0;
    public tag = new TagDTO();
    public tipo: CategoriaFiltroDTO;
    public cuota = 0;
    public cuotaAlcanzada = 0;

    constructor(json: Nilable<Partial<ICuotaDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<ICuotaDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.tag_id != null) {
            this.tag = new TagDTO(json.tag != null ? json.tag : { id: json.tag_id });
        }
        if (json.quota != null) {
            this.cuota = parseInt(json.quota, 10);
        }
        if (json.type != null) {
            this.tipo = new CategoriaFiltroDTO({ id: json.type });
        }
        if (json.reached_quota != null) {
            this.cuotaAlcanzada = json.reached_quota;
        }
    }

    public toJSON(): ICuotaDTO {
        return {
            id: this.id,
            tag_id: this.tag.id,
            quota: this.cuota.toString(),
            reached_quota: null,
            tag: null,
            type: null
        };
    }
}
